import React from "react";

import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {useDispatch,useSelector } from "react-redux";
import CircleNotificationsRoundedIcon from "@mui/icons-material/CircleNotificationsRounded";
import { markasallread } from "../DashBoardView/slice";



const NotificationPanelOpenCardSignalIR = ({
  notificationUnreadCount,
  setOpenNotificationPanel,
  setNotificationMenu,
  t,
  allNotifications,
  onMarkAllAsRead
}) => {
  const handleClick = React.useCallback(() => {
    setOpenNotificationPanel(true);
    setNotificationMenu(null);
  }, []);
  const {
    auth: {
      profile: { address, entity },
      user: { userId },
    }
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const handleClickReadAll = React.useCallback(() => {
        onMarkAllAsRead()
  }, []); 

  return (
    <Card
      sx={{
        background: "#FBEBCB",
        width: "100%",
        padding: "16px",
        my: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
    >
      <CircleNotificationsRoundedIcon sx={{ fontSize: "40px", mb: 1 }} />
      <Typography fontSize={"30px"} fontWeight={"500"} fontFamily={"Poppins"}>
        {notificationUnreadCount}
      </Typography>
      <Typography fontSize={"16px"} variant="body1" fontFamily={"Poppins"}>
        {t("unreadNotifications")}
      </Typography>
      <Button
        sx={{
          background: "white",
          color: "#37773E",
          margin: "15px 0px",
          "&:hover": {
            color: "white",
          },
          borderRadius:"4px"
        }}
        size="large"
        variant="contained"
        fullWidth
        onClick={handleClick}
      >
        {t("seeAll")}
      </Button>
      <Button
        sx={{
          background: "white",
          color: "#37773E",
          margin: "15px 0px",
          "&:hover": {
            color: "white",
          },
          borderRadius:"4px"
        }}
        size="large"
        variant="contained"
        fullWidth
        onClick={handleClickReadAll}
      >
        {"Marcar todas como lidas"}
      </Button>
    </Card>
  );
};

export default NotificationPanelOpenCardSignalIR;
